import { NotificationsLayout } from './layout'
import { NotificationsRoutes } from './routes'

export const NotificationsNavigation = {
  Layout: NotificationsLayout,
  Routes: NotificationsRoutes,
}
